module.exports = __webpack_public_path__ + "static/media/01-home.6c11cc5a.png";